import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import RouteWithSubRoutes from './config.js';
import { createBrowserHistory } from 'history'
// import createHistory from 'history/createBrowserHistory'
const history = createBrowserHistory();
//componets
import App from '../views/index.js';
import About from '../views/about.js';
import Contact from '../views/contact.js';
import Production from '../views/production.js';
import Home from '../views/home.js';
import News from '../views/new.js';
import activities from '../views/activities.js';
import Price from '../views/price.js';

const routes =[
	{
		path:'/',
		component:App,
		Auth:true,
    routes:[
      {
        path:"/",
        component:Home,
        exact:true
      },
      {
        path:'/product/:name',
        component:Production
      },
      {
        path:'/about/:name',
        component:About
      },
      {
        path:'/contact',
        component:Contact
      },
      {
        path:'/activities',
        component:activities
      },
      {
        path:'/news/:id',
        component:News
      },
    ]
  },

]

const RouteConfig= () => (
  <Router history={history}>
    <Switch>
      {routes.map((route, i) => (
        <RouteWithSubRoutes  key={i}  {...route} />
      ))}
    </Switch>
  </Router>
)



export default RouteConfig

// export {routes}



// WEBPACK FOOTER //
// ./public/router/router.js